import { httpClient } from '../../../lib/utils';
import { envValue } from '../../../config/envUtils';
import { languagesWithCodes } from '../../constants/labelsConstants';
import store from '../../store/Store';
import { SAVE_LEVEL } from '../../constants/Level';

//TODO: refactor into service
export function fetchLanguages(hotelId, setLanguageList, setCustomContentLanguageCode) {
    const FRONTMAN_URL = envValue('FRONTMAN_URL');
    const selectedLevel = store.getState().app.selected.level;
    if (selectedLevel === SAVE_LEVEL.HOTEL) {
        return httpClient.get(`${FRONTMAN_URL}/hotel/services/${hotelId}/languages`).then(
            response => {
                const defaultLanguage = response.data.languageList.language.filter(elem => {
                    return elem.isDefault === true;
                });
                setLanguageList(response.data.languageList.language, defaultLanguage[0].code);
                setCustomContentLanguageCode(defaultLanguage[0].code);
                return Promise.resolve([response.data.languageList.language]);
            },
            () => {
                setLanguageList(languagesWithCodes, 'en-US');
                setCustomContentLanguageCode('en-US');
                return Promise.resolve([languagesWithCodes]);
            }
        );
    } else {
        setLanguageList(languagesWithCodes, 'en-US');
        setCustomContentLanguageCode('en-US');
        return Promise.resolve([languagesWithCodes]);
    }
}



// WEBPACK FOOTER //
// ./src/components/helpers/fetchLanguages.js